import { ICommand } from 'core-ts-types';
import * as _4 from 'lodash4';
import { PlatformUtility } from 'utility-ts-platform';
import { ConfirmationNumberService } from '../services/confirmation_number_service';
import { EditPhoneNumberService } from '../services/edit_phone_number_service';
import { NotifyUserService } from '../services/notify_user_service';
export class EditPhoneNumberModalController {
  phoneNumber: string;
  isConfirmationReady: boolean;
  errorMsg: string;
  confirmationNumber: string;
  flags: {
    phoneNumberValid: boolean;
    confirmationValid: boolean;
    confirmationReady: boolean;
    confirmationError: boolean;
  };
  constructor(
    private ngEditPhoneNumberService: EditPhoneNumberService,
    private ngNotifyUserService: NotifyUserService,
    private $timeout: ng.ITimeoutService,
    private updatePhoneNumberCommand: ICommand,
    private ngConfirmationNumberService: ConfirmationNumberService,
    private updateConfirmationNumberCommand: ICommand,
    private updateNotificationSettingsCommand: ICommand,
    private $element: ng.IAugmentedJQuery
  ) {}

  $onInit(): void {
    this.resetData();
  }

  resetData(): void {
    this.errorMsg = '';
    this.confirmationNumber = '';
    this.flags = {
      phoneNumberValid: false,
      confirmationValid: false,
      confirmationReady: false,
      confirmationError: false
    };
  }

  isDesktop() {
    return PlatformUtility.isMobile() ? undefined : true;
  }

  finishAndExit() {
    (this.$element[0].querySelector<HTMLFormElement>('#phone-number-form') as unknown as HTMLFormElement)['reset']();
    this.resetData();
    this.ngEditPhoneNumberService.toggleOpen(false);
  }

  sendPhoneNumber($event?: CustomEvent) {
    if ($event) {
      this.phoneNumber = $event.detail.value.phoneNumber;
    }
    this.updatePhoneNumberCommand(this.phoneNumber).then((response: any) => {
      this.flags.confirmationReady = response;
    });
  }

  async sendConfirmationNumber($event: CustomEvent) {
    const confirmationNumber = $event.detail.value.confirmationNumber;
    const callbackInformation: any = this.ngEditPhoneNumberService.contactConfig;
    this.flags.confirmationError = false;
    try {
      await this.updateConfirmationNumberCommand(confirmationNumber);
      if (!_4.isEmpty(callbackInformation) && callbackInformation.callbackFromToggle) {
        this.updateNotificationSettings(callbackInformation);
      } else {
        this.finishAndExit();
        this.ngNotifyUserService.notifySuccess('Phone number successfully updated.');
      }
    } catch (err) {
      this.$timeout(() => {
        this.flags.confirmationError = true;
        this.errorMsg = err.detail;
      }, 0);
    }
  }

  async updateNotificationSettings(callbackInformation: any) {
    try {
      const response = await this.updateNotificationSettingsCommand(
        callbackInformation.id,
        !callbackInformation.preferenceObj.status,
        callbackInformation.preferenceObj.preferenceType.key.toUpperCase()
      );
      this.flags.confirmationError = false;
      this.ngNotifyUserService.notifySuccess('Phone number successfully updated.');
      const message = `Updated your ${response.updatedCategory.title} ${_4.capitalize(response.channel)} settings.`;
      this.ngNotifyUserService.notifySuccess(message);
      this.finishAndExit();
    } catch (err) {
      this.ngNotifyUserService.notifyError('Error in updating notification settings.');
      callbackInformation.preferenceObj.status = !callbackInformation.preferenceObj.status;
      this.flags.confirmationError = true;
      this.errorMsg = err.data;
    }
  }
}
export class EditPhoneNumberModalComponent implements angular.IComponentOptions {
  public templateUrl: string = 'capability-ng-notification-settings/src/modals/edit_phone_number.html';
  public controller: any = EditPhoneNumberModalController;
  public controllerAs: string = '$ctrl';
}



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-notification-settings/src/modals/edit_phone_number.ts